import VueRouter from 'vue-router';
import Vue from 'vue'

import LandingPage from './pages/LandingPage';
import HomePage from './pages/HomePage';
import GroupPage from './pages/GroupPage';
import GroupNewsPage from './pages/GroupNewsPage';
import GlobalNewsPage from './pages/GlobalNewsPage';
import ViewNewsItemPage from './pages/ViewNewsItemPage';
import AddNewsItemPage from './pages/AddNewsItemPage';
import UpdateNewsItemPage from './pages/UpdateNewsItemPage';
import GlobalCalendarPage from './pages/GlobalCalendarPage';
import GlobalPhotoalbumPage from './pages/GlobalPhotoalbumPage';
import GlobalDocumentsPage from './pages/GlobalDocumentsPage';
import GlobalNewslettersPage from './pages/GlobalNewslettersPage';
import GroupCalendarPage from './pages/GroupCalendarPage';
import AddCalendarItemPage from './pages/AddCalendarItemPage';
import UpdateCalendarItemPage from './pages/UpdateCalendarItemPage';
import ViewCalendarItemPage from './pages/ViewCalendarItemPage';
import GroupPhotoalbumPage from './pages/GroupPhotoalbumPage';
import AddPhotoalbumPage from './pages/AddPhotoalbumPage';
import ViewPhotoalbumPage from './pages/ViewPhotoalbumPage';
import UpdatePhotoalbumPage from './pages/UpdatePhotoalbumPage';
import GroupEmailsPage from './pages/GroupEmailsPage';
import ViewEmailItemPage from './pages/ViewEmailItemPage';
import GroupDocumentsPage from './pages/GroupDocumentsPage';
import AddDocumentItemPage from './pages/AddDocumentItemPage';
import UpdateDocumentItemPage from './pages/UpdateDocumentItemPage';
import GroupAbsencePage from './pages/GroupAbsencePage';
import GlobalAbsencePage from './pages/GlobalAbsencePage';
import AddAbsenceItemPage from './pages/AddAbsenceItemPage';
import UpdateAbsencePage from './pages/UpdateAbsencePage';
import ViewAbsencePage from './pages/ViewAbsencePage';
import ViewPushnotesPage from './pages/ViewPushnotesPage';
import GroupTalksPage from './pages/GroupTalksPage';
import GroupListTalksPage from './pages/GroupListTalksPage';
import ListTalksPage from './pages/ListTalksPage';
//import ViewTalkPage from './pages/ViewTalkPage';
import SettingsPage from './pages/SettingsPage';
import ContactPage from './pages/ContactPage';
import SupportPage from './pages/SupportPage';
import GlobalChatpersonsPage from './pages/GlobalChatpersonsPage';
import ChatPage from './pages/ChatPage';
import WatsonVraagbaakPage from './pages/ViewWatsonVraagbaakPage'

import ViewAbsenceModuleDisabled from './pages/ViewAbsenceModuleDisabled';
import { history } from './services/History.js';

import store from './store/store.js';

Vue.use(VueRouter)
const routes = [
  { path: '/', component: LandingPage },
  { path: '/home', component: HomePage },
  { path: '/settings', component: SettingsPage },
  { path: '/group/:id/news/',
    redirect:"/group/:id/news/init", /* init is non existing feed */
    component: GroupPage,
    meta: {
      reload: true,
    },
  },
  { path: '/group/', component: GroupPage,
   children:[
    { 
      path:'/group/:id/news/:feed',
      component: GroupNewsPage,
    },
    {
      path:'/group/:id/calendar/', 
      component: GroupCalendarPage,
    },
    {
      path:'/group/:id/photoalbum/', 
      component: GroupPhotoalbumPage,
    },
    {
      path:'/group/:id/emails/', 
      component: GroupEmailsPage,
    },
    { 
      path:'/group/:id/documents/', 
      component: GroupDocumentsPage
    },
    {
      path:'/group/:id/absence/',
      component: GroupAbsencePage,
    },
    {
      path:'/group/:id/talks/',
      component: GroupListTalksPage,
    },

   ]},
  {
    path:'/group/:id/talks/:talk_id',
    component: GroupTalksPage,
  },
  {
    path:'/group/:id/absences/',
    component: GlobalAbsencePage,
  },
  { 
    path:'/calendar/:id/add_item/',
    component: AddCalendarItemPage,
  },
  { 
    path:'/documents/:id/add_item/',
    component: AddDocumentItemPage,
  },
  { 
    path:'/documents/:id/update_item/',
    component: UpdateDocumentItemPage,
  },
  { 
    path:'/group/add_absence/:group_id/:parent_id/:child_name',
    component: AddAbsenceItemPage,
  },
  { 
    path:'/group/:id/absence/update/:absence_id',
    component: UpdateAbsencePage,
  },
  { 
    path:'/group/:id/absence/view/:absence_id',
    component: ViewAbsencePage,
  },
  {
    path:'/pushnotes/',
    component:ViewPushnotesPage
  },
  { 
    path:'/calendar/:id/update_item/',
    component:  UpdateCalendarItemPage,
  },
  { 
    path:'/calendar_item/:id',
    component: ViewCalendarItemPage,
  },
  {
    path:'/group/:id/globalnews/:feed', /*id always 0 for global */
    component:GlobalNewsPage,
  },
  {
    path:'/news_item/:id',
    component:ViewNewsItemPage,
  },
  { 
    path:'/group/:id/news/:news_id/add_item/',
    component: AddNewsItemPage,
  },
  {
    path:'/calendar/',
    component:GlobalCalendarPage,
  },
  {
    path:'/absence-module-disabled/',
    component:ViewAbsenceModuleDisabled,
  },
  {
    path:'/albums/',
    component:GlobalPhotoalbumPage,
  },
  { 
    path:'/group/:id/photoalbum/add/', /* group 0 for global */
    component: AddPhotoalbumPage,
  },
  { 
    path:'/group/:id/photoalbum/:album_id/update/',
    component: UpdatePhotoalbumPage,
  },
  { 
    path:'/group/:id/news_item/:item_id/update/',
    component: UpdateNewsItemPage,
  },
  {
    path:'/photoalbum/:id/view',
    component: ViewPhotoalbumPage,
  },
  {
    path:'/email/:id/view',
    component: ViewEmailItemPage,
  },
  {
    path:'/documents/',
    component: GlobalDocumentsPage,
  },
  {
    path:'/newsletters/',
    component: GlobalNewslettersPage,
  },
  {
    path:'/talks/', /* list talks */
    component: ListTalksPage,
  },
  /*
  {
    path:'/group/:id/teacher_talks/', // show talksfor group outside group, there is also a tab in groups to show talks for a group 
    component: ViewTalkPage,
  },
  */
  
  {
    path:'/contact/',
    component: ContactPage,
  },
  {
    path:'/support/',
    component: SupportPage,
  },
  {
    path:'/chatpersons/',
    component: GlobalChatpersonsPage,
  },
  {
    path:'/chat/:person_id',
    component: ChatPage,
  },
  {
    path:'/watson_assistant/',
    component:WatsonVraagbaakPage,
  },
  
  { path: '*', redirect: '/' }
]

const router= new VueRouter({
  //mode: 'history',
  routes, // short for `routes: routes`
  scrollBehavior () { //to, from, savedPosition
    return new Promise(() => {
      // in a timeout, because we need to wait for page out animation
      setTimeout(() => {
        //resolve({ x: 0, y: 0 })
      }, 500)
    })
  }
})


router.beforeEach((to, from, next) => {
 
  if(to.path=="/settings" && !store.state.loggedIn){
    
    // means no loaded data is found or landing directly at settings page
    next();
  }


  if(store.state.loggedIn){
   
      next();
  }else{
    // load user data stored in websql
      store.dispatch("loadStoredData");
      store.dispatch('autoLogin').then(
        ()=>{
          // success
          //alert("should go to:"+to.path);
          router.push({ path: to.path }) // navigate to home page
        },
        ()=>{
          // error
          router.push({ path: '/settings' }) // navigate to settings page
        }
      )}

})


router.afterEach(to=>{
  // adding to history
  history.set(to.fullPath);
});

export default router;